import { HttpErrorResponse } from '@angular/common/http';

export interface CRUDState<T, MESSAGES> {
  created?: CRUDResponse<T, MESSAGES>;
  collectionLoaded?: CRUDResponse<Array<T>, MESSAGES>;
  loaded?: CRUDResponse<T, MESSAGES>;
  updated?: CRUDResponse<T, MESSAGES>;
  deleted?: CRUDResponse<T, MESSAGES>;
}

export interface MetaState<T, MESSAGES> {
  isLoading: boolean;
  isCreating: boolean;
  isDeleting: boolean;
  isUpdating: boolean;
  result: CRUDState<T, MESSAGES>;
}

export const getInitialMetaState = <T, MESSAGES>(): MetaState<T, MESSAGES> => ({
  isLoading: false,
  isCreating: false,
  isDeleting: false,
  isUpdating: false,
  result: {}
});

export interface CRUDResponse<T, MESSAGES> {
  data?: T;
  message: MESSAGES;
  error?: HttpErrorResponse & {metadata?: string};
}

export type CRUDMessages = 'created' | 'createError' | 'loaded' | 'loadError' | 'updated' | 'updateError' | 'deleted' | 'deleteError' | 'collectionLoaded' | 'collectionLoadError' | 'loggedIn' | 'logInError';
